import Model from '@/models/BaseModel'
import i18n from '@/plugins/i18n'
export default class Bill extends Model {
    resourceName() {
        return 'cancellation-requisitions'
    }

    fields() {
        return [
            'customer_id',
            'reason',
            'retained',
            'created_at',
            'note',
            'deleted_at',
        ]
    }

    dates() {
        return {
            created_at: 'YYYY-MM-DD',
            deleted_at: 'YYYY-MM-DD',
        }
    }

    computed() {
        return {
            formattedCreatedAt(cancellationReq) {
                return cancellationReq.created_at.isValid()
                    ? i18n.d(cancellationReq.created_at, 'datetime')
                    : null
            },
            retainedText(cancellationReq) {
                if (cancellationReq.deleted_at.isValid()) {
                    return i18n.t(
                        'resources.cancellationRequisition.getters.retained.deleted',
                    )
                }

                if (cancellationReq.retained == null) {
                    return i18n.t(
                        'resources.cancellationRequisition.getters.retained.null',
                    )
                }

                if (cancellationReq.retained) {
                    return i18n.t(
                        'resources.cancellationRequisition.getters.retained.true',
                    )
                }

                return i18n.t(
                    'resources.cancellationRequisition.getters.retained.false',
                )
            },
        }
    }

    get tableColumns() {
        return [
            {
                text: i18n.t(
                    'resources.cancellationRequisition.attributes.created_at',
                ),
                value: 'formattedCreatedAt',
                sortable: false,
            },
            {
                text: i18n.t(
                    'resources.cancellationRequisition.attributes.reason',
                ),
                value: 'reason',
                sortable: false,
            },
            {
                text: i18n.t(
                    'resources.cancellationRequisition.attributes.retained',
                ),
                value: 'retainedText',
                sortable: false,
            },
            {
                text: i18n.t(
                    'resources.cancellationRequisition.attributes.note',
                ),
                value: 'note',
                sortable: false,
            },
        ]
    }
}
